module.exports = __webpack_public_path__ + "3fa2fd952818865ad466b568dbdf4e00.pdf";